import {
  RECEIVED_VOUCHERS_REQUEST,
  RECEIVED_VOUCHERS_SUCCESS,
  RECEIVED_VOUCHERS_ERROR,
  RECEIVED_VOUCHERS_CLEAR,
} from '../types/receivedVouchersTypes';
import { httpRepo } from 'configurations/axios';
import { getRUCEmpresa } from './userActions';

const API_BASE = '/comprobantes/recibidos/busqueda/';

/**
 * Obtiene los comprobantes recibidos paginados.
 *
 * @param {Object} config
 * @param {string|object} config.rucEmpresa  Token del usuario (se extrae el RUC)
 * @param {number} config.page               Página 0-indexed
 * @param {number} config.elementos          Tamaño de página
 * @param {string} [config.sort]             Ej: "idAsignacionComprobanteElectronico,desc"
 * @param {string} [config.type]             codigoComprobante: "01", "04", etc.
 * @param {string} [config.ini]              Fecha inicio  "2026-01-01T00:00:00"
 * @param {string} [config.fin]              Fecha fin     "2026-12-31T23:59:59"
 */
export const getReceivedVouchersAction = (config) => async (dispatch) => {
  dispatch({ type: RECEIVED_VOUCHERS_REQUEST });

  const ruc = getRUCEmpresa(config.rucEmpresa);

  const queryParams = [
    `page=${config.page}`,
    `size=${config.elementos}`,
    config.sort  ? `sort=${config.sort}`                   : null,
    config.type  ? `codigoComprobante=${config.type}`      : null,
    config.ini   ? `ini=${config.ini}`                     : null,
    config.fin   ? `fin=${config.fin}`                     : null,
  ].filter(Boolean).join('&');

  try {
    const response = await httpRepo.get(`${API_BASE}${ruc}?${queryParams}`);
    dispatch({ type: RECEIVED_VOUCHERS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error.response) {
      console.error('receivedVouchers error', error.response.data);
    } else {
      console.error('receivedVouchers error', error);
    }
    dispatch({ type: RECEIVED_VOUCHERS_ERROR, payload: true });
  }
};

export const clearReceivedVouchersAction = () => ({
  type: RECEIVED_VOUCHERS_CLEAR,
});
